import { Result, Button } from "antd"
import { useNavigate } from "react-router-dom"

const PageNotFound = () => {
  const navigate = useNavigate()
  return (
    <div className="sips">
      <Result
        status="404"
        title="Page not found"
        subTitle="This route does not exist or you do not have access to it."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Back to dashboard
          </Button>
        }
      />
    </div>
  )
}

export default PageNotFound
